var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors[_vm.name])?_c('div',{staticClass:"c-error__text"},_vm._l((_vm.errors[_vm.name]),function(m){return _c('div',{key:m},[_vm._v(" "+_vm._s(m)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }